// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".px35[data-v-2046c57d] {\n  padding: 0 35px;\n}\n.row_title[data-v-2046c57d] {\n  width: 246px;\n}\n.demo-drawer__content[data-v-2046c57d] {\n  padding: 0 30px;\n}", ""]);
// Exports
module.exports = exports;
